import { ResponseTranslation } from '../../Translations';
import { HierarchyLevel } from '../enum/hierarchy-level';

export interface ItemSearchCommand {
  itemCategoryCode?: string;
  name?: string;
  itemCode?: string;
  inventoryTypeReference?: string;
  status?: number[];
  /** Restrict to these ItemClassification master-data codes (e.g. Services); empty = any (#5947). */
  itemClassificationCodes?: string[];
}

/** The ItemClassification master-data code an Administrative purchase order may carry (#5942). */
export const SERVICES_ITEM_CLASSIFICATION_CODE = 'Services';

export interface ItemMaster {
  id: string;
  itemCode: string;
  itemDisplayName: ResponseTranslation;
  inventoryTypeReference: string;
  itemLongDisplayName: ResponseTranslation;
  itemDescription: ResponseTranslation;
  unitOfMeasure: number;
  itemCategoryCode: string;
  itemLowestSubCategoryCode: string;
  itemClassificationCode: string;
  certificationReferences?: string[];
  relationships?: ItemRelationship[];
  status: number;
  sgiCode: number;
  cisCode: number;
  baseYarnCode?: string;
  baseFabricCode?: string;
  baseGreigeCode?: string;
  fieldToDisplay?: string;
}

export interface ItemMasterCodeBatchCommand {
  itemCodes: string[];
}

export interface ItemMasterFilter {
  itemCategoryReference?: string;
  itemCategoryCode?: string;
  itemLowestSubCategoryCode?: string;
  itemCode?: string;
  inventoryTypeReference?: string;
  description?: string;
  name?: string;
  baseYarnCode?: string;
  baseGreigeCode?: string;
}

export interface ItemRelationship {
  itemMasterCode: string;
  relationshipType: number;
  quantity?: number;
  unitOfMeasure?: number;
}

export enum ItemRelationshipType {
  Composition,
}

export enum Uom {
  pct = 7,
}

export interface Certification {
  id: string;
  name: string;
  includedCompositions: string[];
  allCompositions: boolean;
}

export interface ItemCategory {
  id: string;
  code: string;
  mongoDBCollection: string;
  name: ResponseTranslation;
  parentCode: string;
  level: HierarchyLevel;
  selectable: boolean;
  isActive: boolean;
  description: string;
  fieldToDisplay?: string;
}
export interface ItemMasterCodeBatchCommand {
  itemCodes: string[];
}

export interface ItemMasterCodeBatchCommand {
  itemCodes: string[];
}
